import { render, staticRenderFns } from "./PackagedWidgetMetadata.vue?vue&type=template&id=d2c19910&scoped=true&"
import script from "./PackagedWidgetMetadata.vue?vue&type=script&lang=js&"
export * from "./PackagedWidgetMetadata.vue?vue&type=script&lang=js&"
import style0 from "./PackagedWidgetMetadata.vue?vue&type=style&index=0&id=d2c19910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c19910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
